export default "__VITE_ASSET__DLjwVtIb__"